import request from "@/utils/request";
import config from "@/config";

//常用检测项列表查询
export function configCommonItemQuery(data){
    return request({
        url:`${config.serveUrl}/wt/configCommonItem/list`,
        method: 'post',
        data:data,
    })
}

// 暂存
export function appTempSaveOrUpdate(data){
    return request({
        url:`${config.serveUrl}/entrust/appTempSaveOrUpdate`,
        method: 'post',
        data:data,
    })
}

//提交
export function appSaveOrUpdateEntity(data){
    return request({
        url:`${config.serveUrl}/entrust/appSaveOrUpdateEntity`,
        method: 'post',
        data:data,
    })
}
export function appUpdateEntity(data){
    return request({
        url:`${config.serveUrl}/entrust/appUpdateEntity`,
        method: 'post',
        data:data,
    })
}

// 委托单列表
export function getUserPageList(data){
    return request({
        url:`${config.serveUrl}/entrust/getUserPageList`,
        method: 'post',
        data:data,
    })
}
// 获取委托单详情
export function getEntityDetail(id){
    return request({
        url:`${config.serveUrl}/entrust/getEntity?id=${id}`,
        method: 'get',
    
    })
}

// 任务流转单
export function listReportTimeline(id){
    return request({
        url:`${config.serveUrl}/entrust/reportSystem/listReportTimeline?entrustId=${id}`,
        method: 'get',
    
    })
}

// 委托单下载
export function listReportEntrustFileList(id){
    return request({
        url:`${config.serveUrl}/entrust/reportSystem/listReportEntrustFileList?entrustId=${id}`,
        method: 'get',
    
    })
}
// 查询工程项目
export function listBindTenderProjectByCustomerId(data){
    return request({
        url:`${config.serveUrl}/entrust/listBindTenderProjectByCustomerId`,
        method: 'post',
        data:data,
    })
}

// 绑定项目
export function bindTenderProject(data){
    return request({
        url:`${config.serveUrl}/entrust/bindTenderProject`,
        method: 'post',
        data:data,
    })
}


// 委托文件流
export function previewWtdPdfByEntrustId(id){
    return request({
        url:`${config.serveUrl}/entrust/sample/previewWtdPdfByEntrustId?entrustId=${id}`,
        method: 'get',
        responseType:'blob',
        timeout:0,
    })
}

// 进度查询项目列表

export function listBindTenderProjectByCustomerIdNoPage(data){
    return request({
        url:`${config.serveUrl}/entrust/listBindTenderProjectByCustomerIdNoPage`,
        method: 'post',
        data:data,
    })
}


export function saveOrUpdateEntity(data){
    return request.post(`${config.serveUrl}/entrust/saveOrUpdateEntity`,data);
}
///sampleForm/delete
export function sampleFormDelete(id){
    return request.delete(`${config.serveUrl}/sampleForm/delete?id=${id}`,);
}
export function getPageList(data){
    return request.post(`${config.serveUrl}/entrust/getPageList`,data);
}
// 委托单位
export function getTenderProject(params){
    return request({
      url: `${config.serveUrl}/entrust/getTenderProject?entrustUnit=${params}`,
      method: 'get',
      
  })
}
export const getDetailsById=(id:any)=> {
    return request({
        url:config.serveUrl+'/entrust/getEntity?id=' + id,
        method: 'get'
    })
}
// 分配任务

export const getTask=(id:any)=> {
    return request({
        url:config.serveUrl+'/entrust/getTask?entrustId=' + id,
        method: 'get'
    })
}
export function entrustAccept(data){
    return request.post(`${config.serveUrl}/entrust/entrustAccept`,data);
}

// 部门任务wt/taskDoor/getDeptTask

export function getDeptTask(data){
    return request.post(`${config.serveUrl}/wt/taskDoor/getDeptTask`,data);
}

// 修改分配人

export function updatePlanUser(data){
    return request.post(`${config.serveUrl}/wt/taskDoor/updatePlanUser`,data);
}
// 个人任务
export function getUserTask(data){
    return request.post(`${config.serveUrl}/wt/taskDoor/getUserTask`,data);
}

// 确认收样
export function confirmSample(entrustId){
    return request({
      url: `${config.serveUrl}/entrust/sample/confirmSample?entrustId=${entrustId}`,
      method: 'get',
      
  })
}
// 退回收样
export function returnSample(entrustId){
    return request({
      url: `${config.serveUrl}/entrust/sample/returnSample?entrustId=${entrustId}`,
      method: 'get',
      
  })
}
// 上传样品附件
export function uploadSamplePhoto(data){
    return request.post(`${config.serveUrl}/entrust/sample/uploadSamplePhoto`,data);
}
export function getUserTestTask(data){
    return request.post(`${config.serveUrl}/wt/taskDoor/getUserTestTask`,data);
}

// 获取样品名称列表
export function getConfigSample(data){
    return request.post(`${config.serveUrl}/wt/configSample/listOnly`,data);
}

// 获取样品描述列表
export function getConfigDescr(data){
    return request.post(`${config.serveUrl}/wt/configDescr/listOnly`,data);
}
// 样品单位列表
export function getConfigUnit(data){
    return request.post(`${config.serveUrl}/wt/configUnit/listOnly`,data);
}
// 委托流转记录
export function selectOperateRecordList(data){
    return request.post(`${config.serveUrl}/operateRecord/selectOperateRecordList`,data);
}

// 查询任务列表
export function selectTaskList(entrustId){
    return request({
      url: `${config.serveUrl}/operateRecord/selectTaskList?entrustId=${entrustId}`,
      method: 'get',
  })
}
// 查询任务操作记录
export function selectTaskRecord(taskId){
    return request({
      url: `${config.serveUrl}/operateRecord/selectTaskRecord?taskId=${taskId}`,
      method: 'get',
  })
}

//根据工程名称获取相关关联数据 
export function getTenderProjectByName(data){
    return request.post(`${config.serveUrl}/entrust/getTenderProjectByName`,data);
}

//获取项目费用配置信息
export function getProjectFeeCfgInfo(entrustId){
    return request({
      url: `${config.serveUrl}/entrust/getProjectFeeCfgInfo?entrustId=${entrustId}`,
      method: 'get',
      
  })
}

//部门任务 修改为待协商  /
export function updateTaskDoorRecvState(data){
    return request.post(`${config.serveUrl}/wt/taskDoor/updateTaskDoorRecvState`,data);
}

// 个人确认收样
export function taskConfirmSample(taskId){
    return request({
      url: `${config.serveUrl}/wt/taskDoor/taskConfirmSample?taskId=${taskId}`,
      method: 'get',
  })
}
// 工程列表
export function getTenderProjects(data){
    return request.post(`${config.serveUrl}/entrust/getTenderProjects`,data);
}
//获取样品信息
export function getSampleById(data){
    return request.get(`${config.serveUrl}/entrust/sample/getSampleById?id=${data.id}`);
}// 修改信息类报告
export function updateEntrustByUpdate(data){
    return request.post(`${config.serveUrl}/entrust/updateEntrustByUpdate`,data);
}
export function queryAllContractList(data){
    return request.post(`${config.lgtServe}/market/contract/queryAllContractList`,data);
}
export function linkContract(data){
    return request.post(`${config.serveUrl}/entrust/contractLink/linkContract`,data);
}
export function clearLinkContract(data){
    return request.post(`${config.serveUrl}/entrust/contractLink/clearLink`,data);
}
export function generateReceipt(data){
    return request.get(`${config.serveUrl}/receipt/generateReceipt?entrustId=${data}`);
}


export function getReceipt(data){
    return request.get(`${config.serveUrl}/receipt/getReceipt?entrustId=${data}`);
}
//wt/customInvoice/likeInvoice
export function likeInvoice(data){
    return request.post(`${config.lgtServe}/wt/customInvoice/likeInvoice`,data);
}
export function updateReceipt(data){
    return request.post(`${config.serveUrl}/receipt/updateReceipt`,data);
}
export function customInvoiceSave(data){
    return request.post(`${config.lgtServe}/wt/customInvoice/save`,data);
}
//生成PDF
export function generateReceiptPdf(data){
    return request({
        url:`${config.serveUrl}/receipt/generateReceiptPdf?entrustId=${data}`,
        method: 'get',
        timeout:0,
    })
    //return request.post(`${config.lgtServe}/receipt/generateReceiptPdf`,data);
}

// //entrust/sample/getMaxNo
export function getSampleMaxNo(params){
    return request.get(`${config.serveUrl}/entrust/sample/getMaxNo?itemCode=${params.itemCode}`);
}
export function getEntrustMaxNo(){
    return request.post(`${config.serveUrl}/entrust/getMaxNo`);
}
export function copyEntrust(params){
    return request.get(`${config.serveUrl}/entrust/copyEntrust?entityId=${params.id}`);
}
export function listOnlyAuditUser(data){
    return request.post(`${config.serveUrl}/wt/auditUser/listOnly`,data);
}
export function batchUpdatePlanUser(data){
    return request.post(`${config.serveUrl}/wt/taskDoor/batchUpdatePlanUser`,data);
}
export function getProjectByReportGcbh(params){
    return request.get(`${config.serveUrl}/entrust/getProjectByReportGcbh?reportGcbh=${params.reportGcbh}`);
}
export function getDtList(params){
    return request.get(`${config.serveUrl}/entrust/reportSystem/getDtList?reportGcbh=${params.reportGcbh}`);
}
export function pushEntrustToReportSystem(params){
    return request.get(`${config.serveUrl}/entrust/reportSystem/pushEntrustToReportSystem?entrustId=${params.entrustId}`);
}
// 委托单pdf

export function downloadWtdPdf(sampleNo){
    return request({
        url:`${config.serveUrl}/entrust/sample/previewWtdPdf?sampleNo=${sampleNo}`,
        method: 'get',
        timeout:0,
        responseType:"blob"
    })
}


// 获取值班人员
export function getCurrentKfDayPlan(){
    return request.get(`${config.parentServe}/kf/plan/getCurrentKfDayPlan`);
}

// 删除委托单
export function removeEntrustById(id){
    return request.get(`${config.serveUrl}/entrust/removeById?id=${id}`);
}

// 解绑工程
export function unBindTenderProject(reportGcbh){
    return request.get(`${config.serveUrl}/entrust/unBindTenderProject?reportGcbh=${reportGcbh}`);
}


// 我的签名
export function listByBusIdAndType(id){
    return request.get(`${config.serveUrl}/att/listByBusIdAndType?busiType=WeChatSiginFlie&busiId=${id}`);
}

// 删除签名
export function removeAtt(id){
    return request.get(`${config.serveUrl}/attBusi/removeAtt?attId=${id}`);
}

// 批量签名
export function batchUpdateSigns(data){
    return request({
        url:`${config.serveUrl}/entrust/batchUpdateSigns`,
        method: 'post',
        data:data,
    })
}

export function exportUserList(data){
    return request({
        url:`${config.serveUrl}/entrust/exportUserList`,
        method: 'post',
        responseType:'blob',
        timeout:0,
        data
    })
}

// 提交前校验
export function checkRequiredParam(data){
    return request({
        url:`${config.serveUrl}/entrust/checkRequiredParam`,
        method: 'post',
        data:data,
    })
}

// 添加签名
export function addSigns(data){
    return request({
        url:`${config.serveUrl}/attBusi/insertAtt`,
        method: 'post',
        data:data,
    })
}

// 获取委托单同组委托单
export function getOrderList(id){
    return request.get(`${config.serveUrl}/entrust/getOrderList?entrustId=${id}`);
}
// 委托单作废
export function customerRejectEntrust(id){
    return request.get(`${config.serveUrl}/entrust/customerRejectEntrust?entrustId=${id}`);
}

// 委托人见证签名校验

export function forbidSign(id){
    return request.get(`${config.serveUrl}/tender/RegisterReportgc/forbidSign?projectId=${id}`);
}